module.exports = __webpack_public_path__ + "static/media/o8.49cb1a23.png";